import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
  withRouter
} from 'react-router-dom'
import logo from './logo.svg';
import './App.css';
import {Helmet} from "react-helmet";
import SignUp from './routes/SignUp'
import Link from './routes/Link'
import Username from './routes/Username'
import About from './routes/About'
import WailitngList from './routes/WailitngList'

import firebase from 'firebase'

class App extends Component {
  state = {
    user: null,
    loaded: false
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({user, loaded: true})

            // this.props.history.push('/ololo')


        firebase.database().ref('Usernames/' + user.uid)
        .on('value', snap => {
          const username = snap.val()

          if (username) {
            this.setState({username})
            this.props.history.push('/waiting_list')
          } else {
            this.props.history.push('/username')
          }
        })
      } else {
        console.log('asd')
        this.setState({user: null, loaded: true})
      }
    })
  }

  render() {
    const { user, loaded } = this.state

    return (
      <div>
           <Helmet>
        <title>auxcorde</title>
        <meta name="description" content="Helmet application" />
    </Helmet>
         <header>
    <h1 class="logo"> <a href="/"><img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/212585/aux.png" /></a></h1>
  </header>
        <Switch>
          <Route path="/signup" component={SignUp} user={user} />
          <Route path="/wtf" component={About}  />
          <Route path="/link" component={Link} user={user} />
          <Route path="/username" render={props => <Username {...props} {...this.state} />} />
          <Route path="/waiting_list" render={props => <WailitngList {...props} {...this.state} />} />

          {/*<Route path="/about" component={About}/>
                    <Route path="/topics" component={Topics}/>*/}

          <Redirect
            exact
            from='/'
            to='/signup'
          />
        </Switch>
    
      </div>
    );
  }
}

export default withRouter(App)



// WEBPACK FOOTER //
// ./src/App.js